import { ExpandAllIcon } from './ExpandAllIcon';

/**
 * author: Michael Irigoyen
 * id 85080AB7-D860-4D74-86D8-1A2BFF0C0514
 * name expand-all
 * version: 2.7.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/expand-all.svg
 * tags
 */
export const AnimationPlusIcon = ExpandAllIcon;
export default AnimationPlusIcon